interface FloatingSpanProps extends React.PropsWithChildren {}

const FloatingSpan: React.FC<FloatingSpanProps> = ({ children }) => (
  <span style={{ float: "left", marginRight: "8px", marginBottom: "8px" }}>
    {children}
  </span>
);

export default FloatingSpan;
